import { render, staticRenderFns } from "./MajorSave.vue?vue&type=template&id=b1efe8c6&"
import script from "./MajorSave.vue?vue&type=script&lang=js&"
export * from "./MajorSave.vue?vue&type=script&lang=js&"
import style0 from "./MajorSave.vue?vue&type=style&index=0&id=b1efe8c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports